"use client";

import { ChevronLeft as ArrowLeftIcon } from "lucide-react";
import { Button } from "@components/ngg";
import { Heading } from "@components/ui";
import Link from "next/link";

/**
 * Handle runtime errors
 *
 * @url https://nextjs.org/docs/app/building-your-application/routing/error-handling
 */

export default function Error({ error }: { error: Error }) {
  console.error("Site error!", error);

  return (
    <article className="container flex flex-col gap-y-10 p-4 lg:gap-y-20 lg:p-6">
      <header className="flex flex-col-reverse items-start gap-y-10">
        <Heading
          as="h1"
          size={{
            initial: 3,
            lg: 2,
          }}
        >
          An unexpected error occured
        </Heading>
        <Button
          startIcon={<ArrowLeftIcon strokeWidth={1} className="size-6" />}
          className="transform-none bg-transparent p-0 text-base font-normal tracking-wide text-black underline underline-offset-2"
          as={Link}
          href="/"
        >
          Go to homepage
        </Button>
      </header>
    </article>
  );
}
